// Passwords for the optional encrypted recovery PDF.
const ALPHABET = 'abcdefghijkmnpqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ23456789'; // no look-alikes (0/O, 1/l/I)
export const MIN_PASSWORD = 10;

/** 16 random characters in four groups (about 93 bits), easy to copy by hand. */
export function generatePassword(): string {
  const limit = 256 - (256 % ALPHABET.length); // rejection sampling: no modulo bias
  let out = '';
  while (out.length < 16) {
    for (const b of crypto.getRandomValues(new Uint8Array(32))) {
      if (b < limit && out.length < 16) out += ALPHABET[b % ALPHABET.length];
    }
  }
  return out.match(/.{4}/g)!.join('-');
}

export type PasswordProblem = 'tooShort' | null;
export const passwordProblem = (password: string): PasswordProblem => (password.length < MIN_PASSWORD ? 'tooShort' : null);
